var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('detailComponent',{attrs:{"versionId":_vm.otherParams}}),_c('Divider',{attrs:{"dashed":""}},[_c('h3',[_vm._v("审批详情")])]),_c('history',{attrs:{"type":11,"relateId":_vm.otherParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }